"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractDataStrategy = void 0;
class AbstractDataStrategy {
    adjustResponse(response) {
        var _a, _b, _c;
        const responseData = response.data.raw[0];
        if (((_a = responseData.qos) === null || _a === void 0 ? void 0 : _a.timeliness) === 'delayed') {
            responseData.qos = 1;
        }
        else {
            responseData.qos = 0;
        }
        if (((_b = responseData.data) === null || _b === void 0 ? void 0 : _b.length) && !((_c = responseData.meta) === null || _c === void 0 ? void 0 : _c.blendingEntry)) {
            responseData.meta = {
                blendingEntry: {
                    data: [responseData.data[0]],
                    headers: responseData.headers,
                },
            };
        }
    }
}
exports.AbstractDataStrategy = AbstractDataStrategy;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0YS1zdHJhdGVneS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uLy4uL3NyYy9jb250ZW50L2hpc3RvcmljYWwtcHJpY2luZy90aW1lLXNlcmllcy9kYXRhLXN0cmF0ZWdpZXMvZGF0YS1zdHJhdGVneS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFQSxNQUFzQixvQkFBb0I7SUFHNUIsY0FBYyxDQUFDLFFBQTRFOztRQUNqRyxNQUFNLFlBQVksR0FBRyxRQUFRLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUMxQyxJQUFJLENBQUEsTUFBQSxZQUFZLENBQUMsR0FBRywwQ0FBRSxVQUFVLE1BQUssU0FBUyxFQUFFLENBQUM7WUFDN0MsWUFBWSxDQUFDLEdBQUcsR0FBRyxDQUFDLENBQUM7UUFDekIsQ0FBQzthQUFNLENBQUM7WUFDSixZQUFZLENBQUMsR0FBRyxHQUFHLENBQUMsQ0FBQztRQUN6QixDQUFDO1FBRUQsSUFBSSxDQUFBLE1BQUEsWUFBWSxDQUFDLElBQUksMENBQUUsTUFBTSxLQUFJLENBQUMsQ0FBQSxNQUFBLFlBQVksQ0FBQyxJQUFJLDBDQUFFLGFBQWEsQ0FBQSxFQUFFLENBQUM7WUFDakUsWUFBWSxDQUFDLElBQUksR0FBRztnQkFDaEIsYUFBYSxFQUFFO29CQUNYLElBQUksRUFBRSxDQUFDLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUM7b0JBQzVCLE9BQU8sRUFBRSxZQUFZLENBQUMsT0FBTztpQkFDaEM7YUFDSixDQUFDO1FBQ04sQ0FBQztJQUNMLENBQUM7Q0FDSjtBQXBCRCxvREFvQkMifQ==